import { render, staticRenderFns } from "./DispensationDetailsPage.vue?vue&type=template&id=1d6b2fce&scoped=true"
import script from "./DispensationDetailsPage.vue?vue&type=script&lang=js"
export * from "./DispensationDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./DispensationDetailsPage.vue?vue&type=style&index=0&id=1d6b2fce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6b2fce",
  null
  
)

export default component.exports